
export interface ErrorResponse3 {
  code?: string;
  error: string;
  success: boolean;
  timestamp?: string;
}
